export const getReferralLink = (code, type = 'marketplace') => {
  const baseUrl = 'https://konnect.ws';
  const cleanCode = code ? String(code).trim() : '';
  const encodedCode = encodeURIComponent(cleanCode);

  switch (type) {
    case 'business':
      return `${baseUrl}/business?type=business&ref=${encodedCode}`;
    case 'ambassador':
      return `${baseUrl}/ambassadors?type=ambassador&ref=${encodedCode}`;
    case 'wise9ja':
      return `${baseUrl}/wise9ja?konnectrfc=${encodedCode}`;
    case 'marketplace':
    default:
      return `${baseUrl}/marketplace?konnectrfc=${encodedCode}`;
  }
};

export const getContextualReferralLinks = (code) => {
  return {
    business: getReferralLink(code, 'business'),
    ambassador: getReferralLink(code, 'ambassador'),
    wise9ja: getReferralLink(code, 'wise9ja'),
    marketplace: getReferralLink(code, 'marketplace'),
  };
};
